var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-page page2 overflow-y-hidden"},[_c('DependentFields')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }